
import { HeadingTag } from '@rtl/api'
import { Options, Prop, Vue } from 'vue-property-decorator'

import { isContrast } from '../../utils'
import Live from './icons/Live.vue'

@Options({
  name: 'Tag',
  components: {
    Live
  }
})
export default class Tag extends Vue {
  @Prop({ type: Object, required: true })
  readonly tag!: HeadingTag

  @Prop({ type: Boolean, default: false })
  readonly showHashtag!: boolean

  @Prop({ type: Boolean, default: true })
  readonly showColor!: boolean

  @Prop({ type: Boolean, default: false })
  readonly isLink!: boolean

  @Prop({ type: Boolean, default: false })
  readonly preferTagLink!: boolean

  @Prop({ type: Boolean, default: false })
  readonly isLive!: boolean

  get url () {
    return (!this.preferTagLink && this.tag.site?.url) || this.tag.url
  }

  get isContrast () {
    return isContrast(this.tag.tagColor)
  }
}
